import { render, staticRenderFns } from "./VeterinaryMedicalH.vue?vue&type=template&id=2161c264&scoped=true"
import script from "./VeterinaryMedicalH.vue?vue&type=script&lang=js"
export * from "./VeterinaryMedicalH.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryMedicalH.vue?vue&type=style&index=0&id=2161c264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2161c264",
  null
  
)

export default component.exports